module.exports = __webpack_public_path__ + "img/logo-borderplex.2e2b3064.jpg";